import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { of } from 'rxjs';
import { catchError, concatMap, take } from 'rxjs/operators';
import { StorageConfig } from '../../config/storage.config';
import { ITokenResult } from '../auth/interfaces/ITokenResult';
import { AuthService } from '../auth/services/authentication.service';
import { MessageService } from '../services/message.service';
import { LayoutService } from '../services/store/layout.service';

@Injectable({
  providedIn: 'root',
})
export class AppAuthenticationResolver implements Resolve<string | ITokenResult> {
  private authService = inject(AuthService);
  private layoutService = inject(LayoutService);
  private messageService = inject(MessageService);

  public resolve() {
    this.layoutService.setLoadingLocked(true);
    const loginType = localStorage.getItem(StorageConfig.LOGGEDIN_TYPE);

    if (loginType && loginType !== '') {
      this.layoutService.enableAnalytics();
      return of('logged in');
    }

    return this.authService.authenticateApp()?.pipe(
      take(1),
      catchError(() => {
        this.layoutService.setLoadingLocked(false);
        this.messageService.showErrorDialog();
        return of('No data');
      }),
      concatMap((value) => {
        return of(typeof value === 'object' && typeof value.access_token === 'string' ? 'login' : value);
      }),
    );
  }
}
